import React, { useState, useEffect } from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Button, LinearProgress, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TableHead, Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import toast from 'react-hot-toast';
import { Autocomplete } from '@mui/material';
import LeadService from '../../core/services/leadsService';
const AddCustomNotification = ({ open, handleOpen, setOpen, selectedIds, fetchGetNotification, setRowSelection,setPrevCustomNotifications ,customType, searchTerm, OsDevice, SubscriptionDevice, appValue }) => {
    const [createMessage, setCreateMessage] = useState('');
    const [Loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [confirmationModal, setConfirmationModal] = useState(false);
    
    const openConfirmationModal = () => {
        if (!createMessage) {
            return toast.error('Promo message is required');
        }
        try {
            setLoading(true)
            setOpen(false);
            setConfirmationModal(true);
        } finally {
            setLoading(false)
        }

    }

    const handleSaveChange = async () => {
        if (!createMessage) {
            return toast.error('Promo message is required');
        }
        // const selectedUserIds = selectedIds?.filter((user, index, self) =>
        //     index === self.findIndex((t) => (
        //         t.id === user.id && t.name === user.name && t.email === user.email && t.user_type === user.user_type
        //     ))
        // );
        const selectedUserIds = selectedIds?.map((user) => user?.id);
        try {
            setLoading(true);
            const res = await LeadService.AddCustomNotification(createMessage, selectedUserIds);
            if (res.data.success) {
                toast.success(res.data.message);
                setOpen(false);
                fetchGetNotification(customType, searchTerm, OsDevice, SubscriptionDevice, appValue);
                setCreateMessage('');
                setRowSelection('')
                setPrevCustomNotifications([])
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
            setOpen(false);
            setConfirmationModal(false);
        }
    };
    const uniqueUsers = selectedIds?.filter((user, index, self) => {
        return (
            index ===
            self.findIndex(
                (u) =>
                    u.name === user.name &&
                    u.last_name === user.last_name &&
                    u.email === user.email &&
                    u.user_type === user.user_type
            )
        );
    });
    const handleChange = (event) => {
        const value = event.target.value;
        if (value.length <= 255) {
            setCreateMessage(value);
            setError(false);
        } else {
            setError(true);
        }
    };
    const handleClose = () => {
        setOpen(false);
        setCreateMessage('');
        setRowSelection('');
        setPrevCustomNotifications([])

        fetchGetNotification(customType, searchTerm, OsDevice, SubscriptionDevice, appValue);
    };
    const onClose = () => {
        setConfirmationModal(false);
        setCreateMessage('');
        setRowSelection('');
        setPrevCustomNotifications([])
        fetchGetNotification(customType, searchTerm, OsDevice, SubscriptionDevice, appValue);
    };

    
    return (
        <div>
            <Modal open={open}>
                <Box
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '558px',
                        height: 'auto',
                    }}
                    className='modal-resp-settings'
                >
                    <Box style={{ display: 'flex' }}>
                        <Typography
                            style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700',
                                fontFamily: 'inherit'
                            }}
                        >
                            Add Custom Notification
                        </Typography>
                    </Box>
                    <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Box style={{ padding: '20px' }}>
                        <Box style={{ display: 'grid', gap: '20px', marginTop: '10px' }}>
                            <Box>
                                <TextField
                                    fullWidth
                                    id="message"
                                    name="message"
                                    placeholder='Write ...'
                                    multiline
                                    rows={3}
                                    value={createMessage}
                                    sx={{
                                        width: '100%',
                                        minHeight: '200px', // Ensure minimum height
                                        overflowY: 'auto',
                                        '& .MuiInputBase-input': {
                                            minHeight: '60px', // Apply minimum height to the input area
                                        },'& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                    }}
                                    onChange={handleChange}
                                    inputProps={{
                                        maxLength: 256,
                                    }}
                                    error={error}
                                    helperText={error ? 'Character limit exceeded! Maximum 255 characters allowed.' : ''}
                                />
                                <Typography variant="body2" color={error ? 'error' : 'textSecondary'}>
                                    {`${createMessage?.length}/255 characters`}
                                </Typography>
                            </Box>
                        </Box>
                        <Box style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Box>
                                <Button
                                    onClick={openConfirmationModal}
                                    style={{
                                        width: '148px',
                                        height: '43px',
                                        backgroundColor: '#5379BD',
                                        color: 'white',
                                        borderRadius: '8px',
                                        textTransform: 'capitalize',
                                        fontSize: '18px',
                                        fontFamily: 'inherit',
                                    }}
                                    disabled={Loading}
                                >
                                    {' '}
                                    {Loading ? 'Saving...' : 'Save'}
                                    {Loading && (<CircularProgress size="20px" sx={{ visibility: Loading ? '' : 'hidden' }} />)}
                                </Button>
                                
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Dialog
                sx={{
                    mb: 2,
                    borderRadius: '22px',
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                    overflow: 'auto'
                }}
                open={confirmationModal} maxWidth="sm" fullWidth>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Are you sure you want to send the push notification to these users?
                    </Typography>
                    <TableContainer
                        component={Paper}
                        sx={{
                            mb: 2,
                            borderRadius: '22px',
                            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                            maxHeight: '450px',
                            overflowY: 'auto',
                        }}
                    >
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#333' }}>User Name</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#333' }}>Email</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#333' }}>User Type</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {uniqueUsers?.map((user) => {
                                    return(
                                        <TableRow key={user.id}>
                                        <TableCell sx={{ padding: '12px 16px', color: '#555' }}>
                                            {`${user?.name} ${user?.last_name}`}
                                        </TableCell>
                                        <TableCell sx={{ padding: '12px 16px', color: '#555' }}>
                                            {user?.email}
                                        </TableCell>
                                        <TableCell sx={{ padding: '12px 16px', color: '#555' }}>
                                            {user?.user_type === 'isa_agent'
                                                ? 'ICA Agent'
                                                : user?.user_type?.charAt(0).toUpperCase() + user?.user_type?.slice(1)
                                            }
                                        </TableCell>
                                    </TableRow>
                                    )
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="error">Cancel</Button>
                    <Button onClick={handleSaveChange} disabled={Loading} sx={{ backgroundColor: '#5379BD', }} variant="contained">Yes
                        {Loading && (<CircularProgress size="20px" sx={{ visibility: Loading ? '' : 'hidden' }} />)}
                    </Button>

                </DialogActions>
            </Dialog>

        </div>
    );
};

export default AddCustomNotification;
